import { Action } from 'redux';

import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { ChangeExtractRefreshSchedule } from '../AppActionTypes';

export interface ChangeExtractRefreshScheduleAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function changeExtractRefreshSchedule(tasks: IExtractTaskInfo[]): ChangeExtractRefreshScheduleAction {
  return {
    type: ChangeExtractRefreshSchedule,
    tasks
  };
}
